import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "When is a tire considered unrepairable?",
  answer: "A tire is typically unrepairable if the puncture is larger than 1/4 inch, located on the sidewall or shoulder, or if the tire has been driven on while flat, causing internal structural damage. Our Los Angeles technicians perform a full inspection to ensure your safety before recommending a repair."
}, {
  question: "How do I know when a tire needs replacement?",
  answer: "We check tread depth, visible damage, air loss, and the overall tire condition. If replacement is needed, we explain why and review the available options before any work begins."
}, {
  question: "How long does a standard flat tire repair take?",
  answer: "We specialize in fast, same-day service. Most flat tire repairs at our shop are completed within 30 to 45 minutes, getting you back on the road quickly. No appointment is necessary, but you can call ahead to check our current bay availability."
}, {
  question: "Do you service TPMS sensors during tire replacement?",
  answer: "Absolutely. We provide full TPMS (Tire Pressure Monitoring System) services, including sensor testing, battery checks, and recalibration. Ensuring your TPMS is functioning correctly is vital for maintaining optimal tire pressure and fuel efficiency."
}];
export default function DomandeFrequenti() {
  return <section data-section-id="224652" id="common-questions" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-primary/10 blur-[100px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-3xl relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-black text-foreground mb-4 tracking-tighter italic uppercase">
            Common Questions
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default">
            Expert advice on tire maintenance, safety standards, and our rapid repair services in Los Angeles.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-sm px-2 md:px-6 bg-card/40 backdrop-blur-md transition-all duration-300 data-[state=open]:border-primary data-[state=open]:ring-1 data-[state=open]:ring-primary/20 data-[state=open]:bg-card/90 shadow-sm">
              <AccordionTrigger className="text-base md:text-lg font-default font-bold hover:no-underline py-6 text-foreground data-[state=open]:text-primary transition-colors text-left uppercase tracking-tight">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-default text-base leading-relaxed pb-6 pr-4 md:pr-12 border-t border-primary/10 pt-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}